var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuperSaver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666687,
    width: 88,
    height: 88,
    rx: 44,
    fill: "#FDCCD6",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6667 20H20.6667V52C38.3398 52 52.6667 37.6731 52.6667 20Z",
    fill: "#FDCCD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5804 27.2283C32.8515 26.7764 33.3398 26.5 33.8667 26.5H55.4667C55.9936 26.5 56.4818 26.7764 56.7529 27.2283L63.9529 39.2283C64.292 39.7934 64.2225 40.5136 63.7816 41.0034L45.7816 61.0034C45.4972 61.3195 45.0919 61.5 44.6667 61.5C44.2414 61.5 43.8362 61.3195 43.5517 61.0034L25.5517 41.0034C25.1109 40.5136 25.0414 39.7934 25.3804 39.2283L32.5804 27.2283ZM34.716 29.5L29.316 38.5H34.5506L37.2506 29.5H34.716ZM40.3827 29.5L37.6827 38.5H51.6506L48.9506 29.5H40.3827ZM52.0827 29.5L54.7827 38.5H60.0174L54.6174 29.5H52.0827ZM59.2986 41.5H54.6366L49.9745 51.8602L59.2986 41.5ZM44.6667 56.3447L51.3468 41.5H37.9866L44.6667 56.3447ZM34.6968 41.5L39.3589 51.8602L30.0347 41.5H34.6968Z",
    fill: "#F75676"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperSaver);
export default __webpack_public_path__ + "static/media/super_saver.84a3fbe026268db1ea2fff921c9ba913.svg";
export { ForwardRef as ReactComponent };